import app from './app'
import appStore from './appStore'
import channels from './channels'
import myApps from './myApps'
import navigation from './navigation'
import schedules from './schedules'
import screenGroups from './screenGroups'
import screens from './screens'
import session from './session'

export default {
  app,
  appStore,
  channels,
  myApps,
  navigation,
  schedules,
  screenGroups,
  screens,
  session
}
